export enum ChannelItemStatus {
    Scheduled = 0,
    Completed = 1,
    Failed = 2,
    Sending = 3,
}
